/**
 * Модель кодов стран
 */
export const country_alpha = new jqueryts.DataCollection({
    url:function (){
        let data=[
            {
                "name": "Russia",
                "code": "RU",
                "mobileCode": "+7",
                "flag": "🇷🇺"
            },
            {
                "name": "Belarus",
                "code": "BY",
                "mobileCode": "+375",
                "flag": "🇧🇾"
            },
            {
                "name": "China",
                "code": "CN",
                "mobileCode": "+86",
                "flag": "🇨🇳"
            },
            {
                "name": "Afghanistan",
                "code": "AF",
                "mobileCode": "+93",
                "flag": "🇦🇫"
            },
            {
                "name": "Åland Islands",
                "code": "AX",
                "mobileCode": "+358-18",
                "flag": "🇦🇽"
            },
            {
                "name": "Albania",
                "code": "AL",
                "mobileCode": "+355",
                "flag": "🇦🇱"
            },
            {
                "name": "Algeria",
                "code": "DZ",
                "mobileCode": "+213",
                "flag": "🇩🇿"
            },
            {
                "name": "American Samoa",
                "code": "AS",
                "mobileCode": "+1-684",
                "flag": "🇦🇸"
            },
            {
                "name": "Andorra",
                "code": "AD",
                "mobileCode": "+376",
                "flag": "🇦🇩"
            },
            {
                "name": "Angola",
                "code": "AO",
                "mobileCode": "+244",
                "flag": "🇦🇴"
            },
            {
                "name": "Anguilla",
                "code": "AI",
                "mobileCode": "+1-264",
                "flag": "🇦🇮"
            },
            {
                "name": "Antarctica",
                "code": "AQ",
                "mobileCode": "+",
                "flag": "🇦🇶"
            },
            {
                "name": "Antigua and Barbuda",
                "code": "AG",
                "mobileCode": "+1-268",
                "flag": "🇦🇬"
            },
            {
                "name": "Argentina",
                "code": "AR",
                "mobileCode": "+54",
                "flag": "🇦🇷"
            },
            {
                "name": "Armenia",
                "code": "AM",
                "mobileCode": "+374",
                "flag": "🇦🇲"
            },
            {
                "name": "Aruba",
                "code": "AW",
                "mobileCode": "+297",
                "flag": "🇦🇼"
            },
            {
                "name": "Australia",
                "code": "AU",
                "mobileCode": "+61",
                "flag": "🇦🇺"
            },
            {
                "name": "Austria",
                "code": "AT",
                "mobileCode": "+43",
                "flag": "🇦🇹"
            },
            {
                "name": "Azerbaijan",
                "code": "AZ",
                "mobileCode": "+994",
                "flag": "🇦🇿"
            },
            {
                "name": "Bahamas, The",
                "code": "BS",
                "mobileCode": "+1-242",
                "flag": "🇧🇸"
            },
            {
                "name": "Bahrain",
                "code": "BH",
                "mobileCode": "+973",
                "flag": "🇧🇭"
            },
            {
                "name": "Bangladesh",
                "code": "BD",
                "mobileCode": "+880",
                "flag": "🇧🇩"
            },
            {
                "name": "Barbados",
                "code": "BB",
                "mobileCode": "+1-246",
                "flag": "🇧🇧"
            },

            {
                "name": "Belgium",
                "code": "BE",
                "mobileCode": "+32",
                "flag": "🇧🇪"
            },
            {
                "name": "Belize",
                "code": "BZ",
                "mobileCode": "+501",
                "flag": "🇧🇿"
            },
            {
                "name": "Benin",
                "code": "BJ",
                "mobileCode": "+229",
                "flag": "🇧🇯"
            },
            {
                "name": "Bermuda",
                "code": "BM",
                "mobileCode": "+1-441",
                "flag": "🇧🇲"
            },
            {
                "name": "Bhutan",
                "code": "BT",
                "mobileCode": "+975",
                "flag": "🇧🇹"
            },
            {
                "name": "Bolivarian Republic of Venezuela",
                "code": "VE",
                "mobileCode": "+58",
                "flag": "🇻🇪"
            },
            {
                "name": "Bolivia",
                "code": "BO",
                "mobileCode": "+591",
                "flag": "🇧🇴"
            },
            {
                "name": "Bonaire, Sint Eustatius and Saba",
                "code": "BQ",
                "mobileCode": "+599",
                "flag": "🇧🇶"
            },
            {
                "name": "Bosnia and Herzegovina",
                "code": "BA",
                "mobileCode": "+387",
                "flag": "🇧🇦"
            },
            {
                "name": "Botswana",
                "code": "BW",
                "mobileCode": "+267",
                "flag": "🇧🇼"
            },
            {
                "name": "Bouvet Island",
                "code": "BV",
                "mobileCode": "+",
                "flag": "🇧🇻"
            },
            {
                "name": "Brazil",
                "code": "BR",
                "mobileCode": "+55",
                "flag": "🇧🇷"
            },
            {
                "name": "British Indian Ocean Territory",
                "code": "IO",
                "mobileCode": "+246",
                "flag": "🇮🇴"
            },
            {
                "name": "Brunei",
                "code": "BN",
                "mobileCode": "+673",
                "flag": "🇧🇳"
            },
            {
                "name": "Bulgaria",
                "code": "BG",
                "mobileCode": "+359",
                "flag": "🇧🇬"
            },
            {
                "name": "Burkina Faso",
                "code": "BF",
                "mobileCode": "+226",
                "flag": "🇧🇫"
            },
            {
                "name": "Burundi",
                "code": "BI",
                "mobileCode": "+257",
                "flag": "🇧🇮"
            },
            {
                "name": "Cabo Verde",
                "code": "CV",
                "mobileCode": "+238",
                "flag": "🇨🇻"
            },
            {
                "name": "Cambodia",
                "code": "KH",
                "mobileCode": "+855",
                "flag": "🇰🇭"
            },
            {
                "name": "Cameroon",
                "code": "CM",
                "mobileCode": "+237",
                "flag": "🇨🇲"
            },
            {
                "name": "Canada",
                "code": "CA",
                "mobileCode": "+1",
                "flag": "🇨🇦"
            },
            {
                "name": "Cayman Islands",
                "code": "KY",
                "mobileCode": "+1-345",
                "flag": "🇰🇾"
            },
            {
                "name": "Central African Republic",
                "code": "CF",
                "mobileCode": "+236",
                "flag": "🇨🇫"
            },
            {
                "name": "Chad",
                "code": "TD",
                "mobileCode": "+235",
                "flag": "🇹🇩"
            },
            {
                "name": "Chile",
                "code": "CL",
                "mobileCode": "+56",
                "flag": "🇨🇱"
            },

            {
                "name": "Christmas Island",
                "code": "CX",
                "mobileCode": "+61",
                "flag": "🇨🇽"
            },
            {
                "name": "Cocos (Keeling) Islands",
                "code": "CC",
                "mobileCode": "+61",
                "flag": "🇨🇨"
            },
            {
                "name": "Colombia",
                "code": "CO",
                "mobileCode": "+57",
                "flag": "🇨🇴"
            },
            {
                "name": "Comoros",
                "code": "KM",
                "mobileCode": "+269",
                "flag": "🇰🇲"
            },
            {
                "name": "Congo",
                "code": "CG",
                "mobileCode": "+242",
                "flag": "🇨🇬"
            },
            {
                "name": "Congo (DRC)",
                "code": "CD",
                "mobileCode": "+243",
                "flag": "🇨🇩"
            },
            {
                "name": "Cook Islands",
                "code": "CK",
                "mobileCode": "+682",
                "flag": "🇨🇰"
            },
            {
                "name": "Costa Rica",
                "code": "CR",
                "mobileCode": "+506",
                "flag": "🇨🇷"
            },
            {
                "name": "Côte d'Ivoire",
                "code": "CI",
                "mobileCode": "+225",
                "flag": "🇨🇮"
            },
            {
                "name": "Croatia",
                "code": "HR",
                "mobileCode": "+385",
                "flag": "🇭🇷"
            },
            {
                "name": "Cuba",
                "code": "CU",
                "mobileCode": "+53",
                "flag": "🇨🇺"
            },
            {
                "name": "Curaçao",
                "code": "CW",
                "mobileCode": "+599",
                "flag": "🇨🇼"
            },
            {
                "name": "Cyprus",
                "code": "CY",
                "mobileCode": "+357",
                "flag": "🇨🇾"
            },
            {
                "name": "Czech Republic",
                "code": "CZ",
                "mobileCode": "+420",
                "flag": "🇨🇿"
            },
            {
                "name": "Democratic Republic of Timor-Leste",
                "code": "TL",
                "mobileCode": "+670",
                "flag": "🇹🇱"
            },
            {
                "name": "Denmark",
                "code": "DK",
                "mobileCode": "+45",
                "flag": "🇩🇰"
            },
            {
                "name": "Djibouti",
                "code": "DJ",
                "mobileCode": "+253",
                "flag": "🇩🇯"
            },
            {
                "name": "Dominica",
                "code": "DM",
                "mobileCode": "+1-767",
                "flag": "🇩🇲"
            },
            {
                "name": "Dominican Republic",
                "code": "DO",
                "mobileCode": "+1-809 and 1-829",
                "flag": "🇩🇴"
            },
            {
                "name": "Ecuador",
                "code": "EC",
                "mobileCode": "+593",
                "flag": "🇪🇨"
            },
            {
                "name": "Egypt",
                "code": "EG",
                "mobileCode": "+20",
                "flag": "🇪🇬"
            },
            {
                "name": "El Salvador",
                "code": "SV",
                "mobileCode": "+503",
                "flag": "🇸🇻"
            },
            {
                "name": "Equatorial Guinea",
                "code": "GQ",
                "mobileCode": "+240",
                "flag": "🇬🇶"
            },
            {
                "name": "Eritrea",
                "code": "ER",
                "mobileCode": "+291",
                "flag": "🇪🇷"
            },
            {
                "name": "Estonia",
                "code": "EE",
                "mobileCode": "+372",
                "flag": "🇪🇪"
            },
            {
                "name": "Ethiopia",
                "code": "ET",
                "mobileCode": "+251",
                "flag": "🇪🇹"
            },
            {
                "name": "Falkland Islands (Islas Malvinas)",
                "code": "FK",
                "mobileCode": "+500",
                "flag": "🇫🇰"
            },
            {
                "name": "Faroe Islands",
                "code": "FO",
                "mobileCode": "+298",
                "flag": "🇫🇴"
            },
            {
                "name": "Fiji Islands",
                "code": "FJ",
                "mobileCode": "+679",
                "flag": "🇫🇯"
            },
            {
                "name": "Finland",
                "code": "FI",
                "mobileCode": "+358",
                "flag": "🇫🇮"
            },
            {
                "name": "France",
                "code": "FR",
                "mobileCode": "+33",
                "flag": "🇫🇷"
            },
            {
                "name": "French Guiana",
                "code": "GF",
                "mobileCode": "+594",
                "flag": "🇬🇫"
            },
            {
                "name": "French Polynesia",
                "code": "PF",
                "mobileCode": "+689",
                "flag": "🇵🇫"
            },
            {
                "name": "French Southern and Antarctic Lands",
                "code": "TF",
                "mobileCode": "+",
                "flag": "🇹🇫"
            },
            {
                "name": "Gabon",
                "code": "GA",
                "mobileCode": "+241",
                "flag": "🇬🇦"
            },
            {
                "name": "Gambia, The",
                "code": "GM",
                "mobileCode": "+220",
                "flag": "🇬🇲"
            },
            {
                "name": "Georgia",
                "code": "GE",
                "mobileCode": "+995",
                "flag": "🇬🇪"
            },
            {
                "name": "Germany",
                "code": "DE",
                "mobileCode": "+49",
                "flag": "🇩🇪"
            },
            {
                "name": "Ghana",
                "code": "GH",
                "mobileCode": "+233",
                "flag": "🇬🇭"
            },
            {
                "name": "Gibraltar",
                "code": "GI",
                "mobileCode": "+350",
                "flag": "🇬🇮"
            },
            {
                "name": "Greece",
                "code": "GR",
                "mobileCode": "+30",
                "flag": "🇬🇷"
            },
            {
                "name": "Greenland",
                "code": "GL",
                "mobileCode": "+299",
                "flag": "🇬🇱"
            },
            {
                "name": "Grenada",
                "code": "GD",
                "mobileCode": "+1-473",
                "flag": "🇬🇩"
            },
            {
                "name": "Guadeloupe",
                "code": "GP",
                "mobileCode": "+590",
                "flag": "🇬🇵"
            },
            {
                "name": "Guam",
                "code": "GU",
                "mobileCode": "+1-671",
                "flag": "🇬🇺"
            },
            {
                "name": "Guatemala",
                "code": "GT",
                "mobileCode": "+502",
                "flag": "🇬🇹"
            },
            {
                "name": "Guernsey",
                "code": "GG",
                "mobileCode": "+44-1481",
                "flag": "🇬🇬"
            },
            {
                "name": "Guinea",
                "code": "GN",
                "mobileCode": "+224",
                "flag": "🇬🇳"
            },
            {
                "name": "Guinea-Bissau",
                "code": "GW",
                "mobileCode": "+245",
                "flag": "🇬🇼"
            },
            {
                "name": "Guyana",
                "code": "GY",
                "mobileCode": "+592",
                "flag": "🇬🇾"
            },
            {
                "name": "Haiti",
                "code": "HT",
                "mobileCode": "+509",
                "flag": "🇭🇹"
            },
            {
                "name": "Heard Island and McDonald Islands",
                "code": "HM",
                "mobileCode": "+ ",
                "flag": "🇭🇲"
            },
            {
                "name": "Honduras",
                "code": "HN",
                "mobileCode": "+504",
                "flag": "🇭🇳"
            },
            {
                "name": "Hong Kong SAR",
                "code": "HK",
                "mobileCode": "+852",
                "flag": "🇭🇰"
            },
            {
                "name": "Hungary",
                "code": "HU",
                "mobileCode": "+36",
                "flag": "🇭🇺"
            },
            {
                "name": "Iceland",
                "code": "IS",
                "mobileCode": "+354",
                "flag": "🇮🇸"
            },
            {
                "name": "India",
                "code": "IN",
                "mobileCode": "+91",
                "flag": "🇮🇳"
            },
            {
                "name": "Indonesia",
                "code": "ID",
                "mobileCode": "+62",
                "flag": "🇮🇩"
            },
            {
                "name": "Iran",
                "code": "IR",
                "mobileCode": "+98",
                "flag": "🇮🇷"
            },
            {
                "name": "Iraq",
                "code": "IQ",
                "mobileCode": "+964",
                "flag": "🇮🇶"
            },
            {
                "name": "Ireland",
                "code": "IE",
                "mobileCode": "+353",
                "flag": "🇮🇪"
            },
            {
                "name": "Israel",
                "code": "IL",
                "mobileCode": "+972",
                "flag": "🇮🇱"
            },
            {
                "name": "Italy",
                "code": "IT",
                "mobileCode": "+39",
                "flag": "🇮🇹"
            },
            {
                "name": "Jamaica",
                "code": "JM",
                "mobileCode": "+1-876",
                "flag": "🇯🇲"
            },
            {
                "name": "Jan Mayen",
                "code": "SJ",
                "mobileCode": "+47",
                "flag": "🇸🇯"
            },
            {
                "name": "Japan",
                "code": "JP",
                "mobileCode": "+81",
                "flag": "🇯🇵"
            },
            {
                "name": "Jersey",
                "code": "JE",
                "mobileCode": "+44-1534",
                "flag": "🇯🇪"
            },
            {
                "name": "Jordan",
                "code": "JO",
                "mobileCode": "+962",
                "flag": "🇯🇴"
            },
            {
                "name": "Kazakhstan",
                "code": "KZ",
                "mobileCode": "+7",
                "flag": "🇰🇿"
            },
            {
                "name": "Kenya",
                "code": "KE",
                "mobileCode": "+254",
                "flag": "🇰🇪"
            },
            {
                "name": "Kiribati",
                "code": "KI",
                "mobileCode": "+686",
                "flag": "🇰🇮"
            },
            {
                "name": "Korea",
                "code": "KR",
                "mobileCode": "+82",
                "flag": "🇰🇷"
            },
            {
                "name": "Kosovo",
                "code": "XK",
                "mobileCode": "+",
                "flag": "🇽🇰"
            },
            {
                "name": "Kuwait",
                "code": "KW",
                "mobileCode": "+965",
                "flag": "🇰🇼"
            },
            {
                "name": "Kyrgyzstan",
                "code": "KG",
                "mobileCode": "+996",
                "flag": "🇰🇬"
            },
            {
                "name": "Laos",
                "code": "LA",
                "mobileCode": "+856",
                "flag": "🇱🇦"
            },
            {
                "name": "Latvia",
                "code": "LV",
                "mobileCode": "+371",
                "flag": "🇱🇻"
            },
            {
                "name": "Lebanon",
                "code": "LB",
                "mobileCode": "+961",
                "flag": "🇱🇧"
            },
            {
                "name": "Lesotho",
                "code": "LS",
                "mobileCode": "+266",
                "flag": "🇱🇸"
            },
            {
                "name": "Liberia",
                "code": "LR",
                "mobileCode": "+231",
                "flag": "🇱🇷"
            },
            {
                "name": "Libya",
                "code": "LY",
                "mobileCode": "+218",
                "flag": "🇱🇾"
            },
            {
                "name": "Liechtenstein",
                "code": "LI",
                "mobileCode": "+423",
                "flag": "🇱🇮"
            },
            {
                "name": "Lithuania",
                "code": "LT",
                "mobileCode": "+370",
                "flag": "🇱🇹"
            },
            {
                "name": "Luxembourg",
                "code": "LU",
                "mobileCode": "+352",
                "flag": "🇱🇺"
            },
            {
                "name": "Macao SAR",
                "code": "MO",
                "mobileCode": "+853",
                "flag": "🇲🇴"
            },
            {
                "name": "Macedonia, Former Yugoslav Republic of",
                "code": "MK",
                "mobileCode": "+389",
                "flag": "🇲🇰"
            },
            {
                "name": "Madagascar",
                "code": "MG",
                "mobileCode": "+261",
                "flag": "🇲🇬"
            },
            {
                "name": "Malawi",
                "code": "MW",
                "mobileCode": "+265",
                "flag": "🇲🇼"
            },
            {
                "name": "Malaysia",
                "code": "MY",
                "mobileCode": "+60",
                "flag": "🇲🇾"
            },
            {
                "name": "Maldives",
                "code": "MV",
                "mobileCode": "+960",
                "flag": "🇲🇻"
            },
            {
                "name": "Mali",
                "code": "ML",
                "mobileCode": "+223",
                "flag": "🇲🇱"
            },
            {
                "name": "Malta",
                "code": "MT",
                "mobileCode": "+356",
                "flag": "🇲🇹"
            },
            {
                "name": "Man, Isle of",
                "code": "IM",
                "mobileCode": "+44-1624",
                "flag": "🇮🇲"
            },
            {
                "name": "Marshall Islands",
                "code": "MH",
                "mobileCode": "+692",
                "flag": "🇲🇭"
            },
            {
                "name": "Martinique",
                "code": "MQ",
                "mobileCode": "+596",
                "flag": "🇲🇶"
            },
            {
                "name": "Mauritania",
                "code": "MR",
                "mobileCode": "+222",
                "flag": "🇲🇷"
            },
            {
                "name": "Mauritius",
                "code": "MU",
                "mobileCode": "+230",
                "flag": "🇲🇺"
            },
            {
                "name": "Mayotte",
                "code": "YT",
                "mobileCode": "+262",
                "flag": "🇾🇹"
            },
            {
                "name": "Mexico",
                "code": "MX",
                "mobileCode": "+52",
                "flag": "🇲🇽"
            },
            {
                "name": "Micronesia",
                "code": "FM",
                "mobileCode": "+691",
                "flag": "🇫🇲"
            },
            {
                "name": "Moldova",
                "code": "MD",
                "mobileCode": "+373",
                "flag": "🇲🇩"
            },
            {
                "name": "Monaco",
                "code": "MC",
                "mobileCode": "+377",
                "flag": "🇲🇨"
            },
            {
                "name": "Mongolia",
                "code": "MN",
                "mobileCode": "+976",
                "flag": "🇲🇳"
            },
            {
                "name": "Montenegro",
                "code": "ME",
                "mobileCode": "+382",
                "flag": "🇲🇪"
            },
            {
                "name": "Montserrat",
                "code": "MS",
                "mobileCode": "+1-664",
                "flag": "🇲🇸"
            },
            {
                "name": "Morocco",
                "code": "MA",
                "mobileCode": "+212",
                "flag": "🇲🇦"
            },
            {
                "name": "Mozambique",
                "code": "MZ",
                "mobileCode": "+258",
                "flag": "🇲🇿"
            },
            {
                "name": "Myanmar",
                "code": "MM",
                "mobileCode": "+95",
                "flag": "🇲🇲"
            },
            {
                "name": "Namibia",
                "code": "NA",
                "mobileCode": "+264",
                "flag": "🇳🇦"
            },
            {
                "name": "Nauru",
                "code": "NR",
                "mobileCode": "+674",
                "flag": "🇳🇷"
            },
            {
                "name": "Nepal",
                "code": "NP",
                "mobileCode": "+977",
                "flag": "🇳🇵"
            },
            {
                "name": "Netherlands",
                "code": "NL",
                "mobileCode": "+31",
                "flag": "🇳🇱"
            },
            {
                "name": "New Caledonia",
                "code": "NC",
                "mobileCode": "+687",
                "flag": "🇳🇨"
            },
            {
                "name": "New Zealand",
                "code": "NZ",
                "mobileCode": "+64",
                "flag": "🇳🇿"
            },
            {
                "name": "Nicaragua",
                "code": "NI",
                "mobileCode": "+505",
                "flag": "🇳🇮"
            },
            {
                "name": "Niger",
                "code": "NE",
                "mobileCode": "+227",
                "flag": "🇳🇪"
            },
            {
                "name": "Nigeria",
                "code": "NG",
                "mobileCode": "+234",
                "flag": "🇳🇬"
            },
            {
                "name": "Niue",
                "code": "NU",
                "mobileCode": "+683",
                "flag": "🇳🇺"
            },
            {
                "name": "Norfolk Island",
                "code": "NF",
                "mobileCode": "+672",
                "flag": "🇳🇫"
            },
            {
                "name": "North Korea",
                "code": "KP",
                "mobileCode": "+850",
                "flag": "🇰🇵"
            },
            {
                "name": "Northern Mariana Islands",
                "code": "MP",
                "mobileCode": "+1-670",
                "flag": "🇲🇵"
            },
            {
                "name": "Norway",
                "code": "NO",
                "mobileCode": "+47",
                "flag": "🇳🇴"
            },
            {
                "name": "Oman",
                "code": "OM",
                "mobileCode": "+968",
                "flag": "🇴🇲"
            },
            {
                "name": "Pakistan",
                "code": "PK",
                "mobileCode": "+92",
                "flag": "🇵🇰"
            },
            {
                "name": "Palau",
                "code": "PW",
                "mobileCode": "+680",
                "flag": "🇵🇼"
            },
            {
                "name": "Palestinian Authority",
                "code": "PS",
                "mobileCode": "+970",
                "flag": "🇵🇸"
            },
            {
                "name": "Panama",
                "code": "PA",
                "mobileCode": "+507",
                "flag": "🇵🇦"
            },
            {
                "name": "Papua New Guinea",
                "code": "PG",
                "mobileCode": "+675",
                "flag": "🇵🇬"
            },
            {
                "name": "Paraguay",
                "code": "PY",
                "mobileCode": "+595",
                "flag": "🇵🇾"
            },
            {
                "name": "Peru",
                "code": "PE",
                "mobileCode": "+51",
                "flag": "🇵🇪"
            },
            {
                "name": "Philippines",
                "code": "PH",
                "mobileCode": "+63",
                "flag": "🇵🇭"
            },
            {
                "name": "Pitcairn Islands",
                "code": "PN",
                "mobileCode": "+870",
                "flag": "🇵🇳"
            },
            {
                "name": "Poland",
                "code": "PL",
                "mobileCode": "+48",
                "flag": "🇵🇱"
            },
            {
                "name": "Portugal",
                "code": "PT",
                "mobileCode": "+351",
                "flag": "🇵🇹"
            },
            {
                "name": "Puerto Rico",
                "code": "PR",
                "mobileCode": "+1-787 and 1-939",
                "flag": "🇵🇷"
            },
            {
                "name": "Qatar",
                "code": "QA",
                "mobileCode": "+974",
                "flag": "🇶🇦"
            },
            {
                "name": "Reunion",
                "code": "RE",
                "mobileCode": "+262",
                "flag": "🇷🇪"
            },
            {
                "name": "Romania",
                "code": "RO",
                "mobileCode": "+40",
                "flag": "🇷🇴"
            },

            {
                "name": "Rwanda",
                "code": "RW",
                "mobileCode": "+250",
                "flag": "🇷🇼"
            },
            {
                "name": "Saint Barthélemy",
                "code": "BL",
                "mobileCode": "+590",
                "flag": "🇧🇱"
            },
            {
                "name": "Saint Helena, Ascension and Tristan da Cunha",
                "code": "SH",
                "mobileCode": "+290",
                "flag": "🇸🇭"
            },
            {
                "name": "Saint Kitts and Nevis",
                "code": "KN",
                "mobileCode": "+1-869",
                "flag": "🇰🇳"
            },
            {
                "name": "Saint Lucia",
                "code": "LC",
                "mobileCode": "+1-758",
                "flag": "🇱🇨"
            },
            {
                "name": "Saint Martin (French part)",
                "code": "MF",
                "mobileCode": "+590",
                "flag": "🇲🇫"
            },
            {
                "name": "Saint Pierre and Miquelon",
                "code": "PM",
                "mobileCode": "+508",
                "flag": "🇵🇲"
            },
            {
                "name": "Saint Vincent and the Grenadines",
                "code": "VC",
                "mobileCode": "+1-784",
                "flag": "🇻🇨"
            },
            {
                "name": "Samoa",
                "code": "WS",
                "mobileCode": "+685",
                "flag": "🇼🇸"
            },
            {
                "name": "San Marino",
                "code": "SM",
                "mobileCode": "+378",
                "flag": "🇸🇲"
            },
            {
                "name": "São Tomé and Príncipe",
                "code": "ST",
                "mobileCode": "+239",
                "flag": "🇸🇹"
            },
            {
                "name": "Saudi Arabia",
                "code": "SA",
                "mobileCode": "+966",
                "flag": "🇸🇦"
            },
            {
                "name": "Senegal",
                "code": "SN",
                "mobileCode": "+221",
                "flag": "🇸🇳"
            },
            {
                "name": "Serbia",
                "code": "RS",
                "mobileCode": "+381",
                "flag": "🇷🇸"
            },
            {
                "name": "Seychelles",
                "code": "SC",
                "mobileCode": "+248",
                "flag": "🇸🇨"
            },
            {
                "name": "Sierra Leone",
                "code": "SL",
                "mobileCode": "+232",
                "flag": "🇸🇱"
            },
            {
                "name": "Singapore",
                "code": "SG",
                "mobileCode": "+65",
                "flag": "🇸🇬"
            },
            {
                "name": "Sint Maarten (Dutch part)",
                "code": "SX",
                "mobileCode": "+599",
                "flag": "🇸🇽"
            },
            {
                "name": "Slovakia",
                "code": "SK",
                "mobileCode": "+421",
                "flag": "🇸🇰"
            },
            {
                "name": "Slovenia",
                "code": "SI",
                "mobileCode": "+386",
                "flag": "🇸🇮"
            },
            {
                "name": "Solomon Islands",
                "code": "SB",
                "mobileCode": "+677",
                "flag": "🇸🇧"
            },
            {
                "name": "Somalia",
                "code": "SO",
                "mobileCode": "+252",
                "flag": "🇸🇴"
            },
            {
                "name": "South Africa",
                "code": "ZA",
                "mobileCode": "+27",
                "flag": "🇿🇦"
            },
            {
                "name": "South Georgia and the South Sandwich Islands",
                "code": "GS",
                "mobileCode": "+",
                "flag": "🇬🇸"
            },
            {
                "name": "South Sudan",
                "code": "SS",
                "mobileCode": "+211",
                "flag": "🇸🇸"
            },
            {
                "name": "Spain",
                "code": "ES",
                "mobileCode": "+34",
                "flag": "🇪🇸"
            },
            {
                "name": "Sri Lanka",
                "code": "LK",
                "mobileCode": "+94",
                "flag": "🇱🇰"
            },
            {
                "name": "Sudan",
                "code": "SD",
                "mobileCode": "+249",
                "flag": "🇸🇩"
            },
            {
                "name": "Suriname",
                "code": "SR",
                "mobileCode": "+597",
                "flag": "🇸🇷"
            },
            {
                "name": "Svalbard",
                "code": "SJ",
                "mobileCode": "+47",
                "flag": "🇸🇯"
            },
            {
                "name": "Swaziland",
                "code": "SZ",
                "mobileCode": "+268",
                "flag": "🇸🇿"
            },
            {
                "name": "Sweden",
                "code": "SE",
                "mobileCode": "+46",
                "flag": "🇸🇪"
            },
            {
                "name": "Switzerland",
                "code": "CH",
                "mobileCode": "+41",
                "flag": "🇨🇭"
            },
            {
                "name": "Syria",
                "code": "SY",
                "mobileCode": "+963",
                "flag": "🇸🇾"
            },
            {
                "name": "Taiwan",
                "code": "TW",
                "mobileCode": "+886",
                "flag": "🇹🇼"
            },
            {
                "name": "Tajikistan",
                "code": "TJ",
                "mobileCode": "+992",
                "flag": "🇹🇯"
            },
            {
                "name": "Tanzania",
                "code": "TZ",
                "mobileCode": "+255",
                "flag": "🇹🇿"
            },
            {
                "name": "Thailand",
                "code": "TH",
                "mobileCode": "+66",
                "flag": "🇹🇭"
            },
            {
                "name": "Togo",
                "code": "TG",
                "mobileCode": "+228",
                "flag": "🇹🇬"
            },
            {
                "name": "Tokelau",
                "code": "TK",
                "mobileCode": "+690",
                "flag": "🇹🇰"
            },
            {
                "name": "Tonga",
                "code": "TO",
                "mobileCode": "+676",
                "flag": "🇹🇴"
            },
            {
                "name": "Trinidad and Tobago",
                "code": "TT",
                "mobileCode": "+1-868",
                "flag": "🇹🇹"
            },
            {
                "name": "Tunisia",
                "code": "TN",
                "mobileCode": "+216",
                "flag": "🇹🇳"
            },
            {
                "name": "Turkey",
                "code": "TR",
                "mobileCode": "+90",
                "flag": "🇹🇷"
            },
            {
                "name": "Turkmenistan",
                "code": "TM",
                "mobileCode": "+993",
                "flag": "🇹🇲"
            },
            {
                "name": "Turks and Caicos Islands",
                "code": "TC",
                "mobileCode": "+1-649",
                "flag": "🇹🇨"
            },
            {
                "name": "Tuvalu",
                "code": "TV",
                "mobileCode": "+688",
                "flag": "🇹🇻"
            },
            {
                "name": "U.S. Minor Outlying Islands",
                "code": "UM",
                "mobileCode": "+1",
                "flag": "🇺🇲"
            },
            {
                "name": "Uganda",
                "code": "UG",
                "mobileCode": "+256",
                "flag": "🇺🇬"
            },
            {
                "name": "Ukraine",
                "code": "UA",
                "mobileCode": "+380",
                "flag": "🇺🇦"
            },
            {
                "name": "United Arab Emirates",
                "code": "AE",
                "mobileCode": "+971",
                "flag": "🇦🇪"
            },
            {
                "name": "United Kingdom",
                "code": "GB",
                "mobileCode": "+44",
                "flag": "🇬🇧"
            },
            {
                "name": "United States",
                "code": "US",
                "mobileCode": "+1",
                "flag": "🇺🇸"
            },
            {
                "name": "Uruguay",
                "code": "UY",
                "mobileCode": "+598",
                "flag": "🇺🇾"
            },
            {
                "name": "Uzbekistan",
                "code": "UZ",
                "mobileCode": "+998",
                "flag": "🇺🇿"
            },
            {
                "name": "Vanuatu",
                "code": "VU",
                "mobileCode": "+678",
                "flag": "🇻🇺"
            },
            {
                "name": "Vatican City",
                "code": "VA",
                "mobileCode": "+379",
                "flag": "🇻🇦"
            },
            {
                "name": "Vietnam",
                "code": "VN",
                "mobileCode": "+84",
                "flag": "🇻🇳"
            },
            {
                "name": "Virgin Islands, U.S.",
                "code": "VI",
                "mobileCode": "+1-340",
                "flag": "🇻🇮"
            },
            {
                "name": "Virgin Islands, British",
                "code": "VG",
                "mobileCode": "+1-284",
                "flag": "🇻🇬"
            },
            {
                "name": "Wallis and Futuna",
                "code": "WF",
                "mobileCode": "+681",
                "flag": "🇼🇫"
            },
            {
                "name": "Yemen",
                "code": "YE",
                "mobileCode": "+967",
                "flag": "🇾🇪"
            },
            {
                "name": "Zambia",
                "code": "ZM",
                "mobileCode": "+260",
                "flag": "🇿🇲"
            },
            {
                "name": "Zimbabwe",
                "code": "ZW",
                "mobileCode": "+263",
                "flag": "🇿🇼"
            }
        ]
        data=data.map(el=>{
            el.id=el.code
            return el
        })
        return data
    }
});

